<template>
    <Modal v-model="modal"
           :title="$t('关联资源')"
           width="600"
           :mask-closable="false"
           @on-cancel="cancel">
        <loading v-if="modloading"
                 style="min-height:100px;" />
        <div v-else
             class="associatedusers">
            <Form ref="formdate"
                  :model="formdate"
                  :rules="ruleValidate"
                  :label-width="120">
                <template v-for="(item,index) in resourceArr">
                    <FormItem :label="item.resourceName+':'"
                              :prop="item.key"
                              :key="index">
                        <Select v-model="formdate[item.resourceType].resources"
                                multiple
                                style="width:80%"
                                :placeholder="$t('请选择')+$t('关联资源')">
                            <Option v-for="(resouce,resI) in item.resources"
                                    :key="resI"
                                    :value="resouce.id"
                                    :label="resouce.name">
                                <div class="option-content">
                                    <div :title="resouce.name"
                                         class="option-name">{{resouce.name}}
                                    </div>
                                    <div>{{resouce.statusName}}</div>
                                </div>
                            </Option>
                        </Select>
                    </FormItem>
                </template>
            </Form>
        </div>
        <div slot="footer">
            <Button type="text"
                    @click="cancel">{{$t('取消')}}</Button>
            <Button type="primary"
                    :loading="loading"
                    @click="submit">{{loading ? $t('提交中'):$t('保存')}}</Button>
        </div>
    </Modal>
</template>
<script>
import API from '@/service/api'
import loading from '@/views/components/basic/loading.vue'
export default {
    name: 'associatedresource',
    components: { loading },
    data () {
        return {
            modal: false,
            loading: false,
            modloading: false,
            formdate: {},
            ruleValidate: {},
            resourceArr: []
        }
    },
    methods: {
        open (data) {
            const { policySid } = data
            this.modal = true
            this.modloading = true
            this.formdate.policyId = policySid
            this.axios.get(this.urlFormat(API.ACCESS_POLICES_RELATION_RESOURCE, false, [policySid])).then(res => {
                this.modloading = false
                this.resourceArr = res
                // 处理数据
                this.resourceArr.forEach(item => {
                    item.key = 'resources'
                    const selectArr = item.resources.filter(titem => titem.isRelation === true)
                    const newslect = []
                    selectArr.forEach(slect => {
                        newslect.push(slect.id)
                    })
                    this.formdate[item.resourceType] = {}
                    this.formdate[item.resourceType].resources = JSON.parse(JSON.stringify(newslect))
                    // console.log(this.formdate, 'this.formdate')
                })
            })
        },
        submit () {
            this.$refs.formdate.validate((valid) => {
                if (valid) {
                    this.loading = true
                    this.axios.put(this.urlFormat(API.ACCESS_POLICES_RELATION_RESOURCE, false), this.formdate).then(res => {
                        this.loading = false
                        this.$emit('refresh')
                        this.cancel()
                    }).catch(e => {
                        this.loading = false
                    })
                } else {
                    // this.$Message.error('Fail!')
                }
            })
        },
        cancel () {
            this.$refs.formdate.resetFields()
            this.modal = false
            this.loading = false
        }
    }
}
</script>
<style lang="less" scoped>
.option-content {
    display: flex;
    justify-content: space-between;
    width: 90%;
}
.option-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
